import React from 'react';
import { BookOpenIcon, ZapIcon, SmartphoneIcon, HomeIcon } from 'lucide-react';
import { CTAButton } from './CTAButton';
import { PriceBlock } from './PriceBlock';
import { HERO_IMAGE_URL } from '../utils/headMeta';
import { PRODUCT_FACTS } from './salesData';
const HERO_IMG = HERO_IMAGE_URL;
/** Intrinsic size of the mockup — used to reserve layout space (avoids CLS). */
const HERO_IMG_WIDTH = 1254;
const HERO_IMG_HEIGHT = 1254;
const badges = [{
  icon: BookOpenIcon,
  label: '145 páginas'
}, {
  icon: ZapIcon,
  label: 'Acceso inmediato'
}, {
  icon: HomeIcon,
  label: 'Cocina hogareña'
}, {
  icon: SmartphoneIcon,
  label: '100% digital'
}];
export function Hero() {
  return <section className="relative overflow-hidden bg-cream" data-id="element-164" data-mp="nc85mj0cxcgf">
      <div className="pointer-events-none absolute -top-28 left-1/2 h-72 w-[34rem] -translate-x-1/2 rounded-full bg-sand blur-3xl" aria-hidden data-id="element-165" data-mp="nbygexn4z9bs" />

      <div className="relative mx-auto max-w-3xl px-5 pb-8 pt-5 text-center sm:pb-12 sm:pt-9" data-id="element-166" data-mp="381e2xgfbobvm">
        <div className="animate-hero-copy" data-id="element-167" data-mp="3j8977bv8e9p0">
          <p className="inline-flex items-center gap-2 rounded-full border border-stone bg-white px-3.5 py-1.5 font-display text-[0.6rem] font-bold uppercase tracking-editorial text-gold-deep shadow-[0_6px_18px_-12px_rgba(56,37,34,0.4)] sm:text-[0.66rem]" data-id="element-168" data-mp="3j6fxtot8hbdb">
            <span className="h-1.5 w-1.5 rounded-full bg-gold" aria-hidden data-id="element-169" data-mp="3e8egp9fdbm4h" />
            Sistema práctico + 60 recetas + 5 bonos
          </p>
          <h1 className="mx-auto mt-4 max-w-[16ch] font-display text-[2rem] font-extrabold uppercase leading-[1.05] tracking-tight text-charcoal sm:max-w-[20ch] sm:text-[3rem]" data-id="element-170" data-mp="30fya5yn9d5yt">
            No necesitás otras 500 recetas.
            <span className="mt-1.5 block text-gold" data-id="element-171" data-mp="2viy4houbm588">Necesitás saber con cuáles empezar.</span>
          </h1>
          <p className="mx-auto mt-4 max-w-[40ch] font-sans text-[0.9rem] leading-relaxed text-taupe sm:max-w-2xl sm:text-[1rem]" data-id="element-172" data-mp="2hjf2zew0ls4w">
            <strong className="font-bold text-charcoal" data-id="element-173" data-mp="2ljgyf6b5ppbq">Postres que Venden™</strong> te muestra qué
            preparar, cómo organizar tu cocina, cuánto cobrar y cómo convertir{' '}
            <strong className="font-semibold text-gold-deep" data-id="element-174" data-mp="nb1j0zx5pjub">tus primeros postres</strong> en una
            oportunidad real de <strong className="font-semibold text-gold-deep" data-id="element-175" data-mp="id04msaoe8p6">generar ingresos desde casa</strong>.
          </p>
        </div>

        <div className="relative mx-auto mt-5 w-[80%] max-w-[330px] sm:mt-7 sm:w-[82%] sm:max-w-[470px]" data-id="element-176" data-mp="db2c17gdy1jk">
          <span className="absolute inset-x-4 bottom-6 top-8 -z-0 rounded-[3rem] bg-coral-soft blur-2xl" aria-hidden data-id="element-177" data-mp="1ayt68yk8jhad" />
          <img src={HERO_IMG} alt="Mockup oficial del libro Postres que Venden™" width={HERO_IMG_WIDTH} height={HERO_IMG_HEIGHT} fetchPriority="high" decoding="async" sizes="(max-width: 640px) 80vw, 470px" style={{
          aspectRatio: `${HERO_IMG_WIDTH} / ${HERO_IMG_HEIGHT}`
        }} className="animate-hero-media relative block h-auto w-full object-contain drop-shadow-[0_26px_34px_rgba(56,37,34,0.22)]" data-id="element-178" data-mp="111ol9224lrv5" />
        </div>

        <p className="mt-3 font-display text-[1.3rem] font-extrabold uppercase leading-none tracking-tight text-charcoal sm:text-[1.7rem]" data-id="element-179" data-mp="21b63fwja2ym4">
          Postres que Venden™
        </p>
        <p className="mt-2 font-sans text-[0.85rem] font-medium text-taupe sm:text-[0.95rem]" data-id="element-180" data-mp="2b1hl0lvvx6bh">
          Ebook de 145 páginas + Método M.V.P.™{' '}
          <strong className="font-bold text-gold-deep" data-id="element-181" data-mp="2kyvo7jssrylu">+ 5 bonos incluidos</strong>
        </p>

        <PriceBlock className="mt-4" data-id="element-182" data-mp="2l0q7ktof7int" />

        <div className="mt-5 flex justify-center" data-id="element-183" data-mp="2p1jy7ut8zbke">
          <CTAButton className="w-full max-w-[26rem] px-4" data-id="element-184" data-mp="2oyo0a6hegmvy" />
        </div>

        <p className="mt-3 font-sans text-[0.75rem] font-medium text-taupe" data-id="element-185" data-mp="2tz20518ukqiw">
          Acceso inmediato · 100% digital · Aplicalo desde tu propia cocina
        </p>
        <p className="mt-1 font-sans text-[0.72rem] text-taupe/80" data-id="element-186" data-mp="zkra4pginqbj">
          🔒 Pago seguro · Mercado Pago · Tarjetas de crédito
        </p>

        <div className="mt-6 flex flex-wrap items-center justify-center gap-2" data-id="element-187" data-mp="49jf0ae80xor">
          {badges.map(b => <span key={b.label} className="inline-flex items-center gap-1.5 rounded-full border border-stone bg-white px-3 py-1.5 font-sans text-[0.68rem] font-semibold text-charcoal/80" data-id="element-188" data-mp="3vk1ijwwclywp">
              <b.icon className="h-3.5 w-3.5 text-gold" aria-hidden strokeWidth={2.5} data-id="element-189" data-mp="3hpr3k7a5lj3u" />
              {b.label}
            </span>)}
        </div>
      </div>

      <div className="relative border-t border-stone bg-white" data-id="element-190" data-mp="3cpcr8d1irn00">
        <div className="mx-auto flex max-w-4xl flex-wrap items-center justify-center gap-x-4 gap-y-1.5 px-5 py-3.5 text-center font-display text-[0.7rem] font-semibold uppercase tracking-[0.08em] text-charcoal sm:text-[0.75rem]" data-id="element-191" data-mp="3rgve8ussqhsv">
          {PRODUCT_FACTS.map((fact, i) => <React.Fragment key={fact} data-id="element-192" data-mp="2u1hkhd4br9ge" data-mpi={i}>
              {i > 0 && <span className="h-1.5 w-1.5 rounded-full bg-gold" aria-hidden data-id="element-193" data-mp="2tylklj8x2apb" />}
              <span data-id="element-194" data-mp="19hcgs7bgztb5">{fact}</span>
            </React.Fragment>)}
        </div>
      </div>
    </section>;
}